<div class="container">
  <div class="row vertical-align">
    <div class="col-md-6 col-sm-6 col-xs-12">
      <h1 class="text-headline">{{getFieldLabel("nl_heading")}}</h1>

      <!-- .../error/email -->
      <div *ngIf="getErrorMessage() == 'email'">
        <p>{{getFieldLabel("nl_warning_mail_exists")}}</p>
      </div>
      <!-- .../error/nms -->
      <div *ngIf="getErrorMessage() == 'nms'">
        <p>{{getFieldLabel("nl_warning_mail_not_sent")}}</p>
      </div>
      <!-- .../error/error -->
      <div *ngIf="getErrorMessage() == 'error'">
        <p>{{getFieldLabel("nl_warning")}}</p>
        <p>{{getFieldLabel("nl_service_nr")}}<br>{{getFieldLabel("nl_service_time")}}</p>
      </div>
      <!-- .../error/invalidlink -->
      <div *ngIf="getErrorMessage() == 'invalidlink'">
        <p>{{getFieldLabel("nl_warning_invalid")}}</p>
      </div>
      <!-- .../error/? -->
      <div *ngIf="getErrorMessage() == 'unknown'">
        <p>Die Seite ist nicht verfügbar.</p>
        <p>Bitte Kontaktieren Sie einen Kundenbetreuer.</p>
      </div>

      <button type="button" id="nl_back_btn" name="nl_back_btn"
              class="button-rounded"><a href="{{getHref()}}">{{getFieldLabel("nl_back_btn")}}</a></button>
    </div>
    <div class="col-md-4 col-sm-4 hidden-xs">
      <img class="img-responsive nlImg" src="{{newsletterImage}}"/>
    </div>
  </div>
</div>
